import { Box } from "@mui/material";

const SiderBorder = () => {
  return (
    <Box
      sx={{ width: "10px", height: "25px", backgroundColor: "#2a9941",margin:"0px 10px",display:"inline-block" }}
    ></Box>
  );
};

export default SiderBorder;
